// extracted by mini-css-extract-plugin
export default {"card":"FeatureCard_card__uN5Bj","avatar":"FeatureCard_avatar__vn276","button":"FeatureCard_button__GKZbB"};